import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ArrowLeft, Loader2, ShieldCheck } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_c5288981-1cfe-4202-bbfa-1fa74e8ddd2d/artifacts/nf5at2sb_6eb7c94a-c17d-437b-a6c9-9665777e6cb6.png";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user && user.role === "admin") nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bem-vindo(a)!");
      nav("/admin", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex" style={{ background: "var(--bg-cream)" }}>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-stone-900 mb-8 transition-colors"
            data-testid="back-to-home"
          >
            <ArrowLeft className="h-4 w-4" /> Voltar ao evento
          </Link>
          <div className="flex items-center gap-3 mb-8">
            <img src={LOGO_URL} alt="Renascer" className="h-14 w-14 object-contain" />
            <div>
              <div className="text-xs uppercase tracking-widest text-orange-700 font-semibold">Painel administrativo</div>
              <div className="font-display text-2xl font-bold">Encontrão Renascer</div>
            </div>
          </div>

          <form onSubmit={submit} className="bg-white border border-stone-200 rounded-2xl p-8 card-warm-shadow space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="admin@renascer.com"
                className="mt-1"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="mt-1"
                data-testid="admin-password-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-red-700 to-orange-600 hover:from-red-800 hover:to-orange-700 text-white font-semibold py-6"
              data-testid="admin-login-submit"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <ShieldCheck className="h-4 w-4 mr-2" />}
              Entrar
            </Button>
            <p className="text-xs text-stone-500 text-center pt-2">
              Acesso restrito à equipe organizadora.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
